<agpr-panel
    *ngIf="panelToggleable"
    [id]="id"
    class="agpr-fileUpload"
    [toggleable]="true"
    [contentPadding]="true"
    [header]="uppercaseHeader ? (header | localize | uppercase) : (header | localize)"
    [tooltip]="headerTooltip"
    [showSubHeader]="showPanelSubHeader"
    [showCustomHeader]="showPanelCustomHeader"
    [subHeaderTemplate]="fileUploadSubHeader"
>
    <ng-template #panelHeader>
        <div class="agpr-fileUpload-iconButton">
            <agpr-button
                id="fileUpload.uploadButton"
                tooltip="Mention.editDialog.attachments.upload.tooltip"
                [disabled]="value?.length >= maxFiles || disabled"
                [style]="buttonTypes.icon"
                [icon]="uploadButtonIcon"
                [label]="uploadButtonLabel | localize | uppercase"
                (click)="useContentLibraryUpload ? uploadButtonClick.emit() : fileUploadInput.click()"
            ></agpr-button>
        </div>
    </ng-template>

    <ng-container *ngTemplateOutlet="inputContent"></ng-container>
</agpr-panel>
<div *ngIf="!panelToggleable" class="agpr-fileUpload">
    <div
        class="agpr-fileUpload-header"
    >
        <span class="agpr-fileUpload-header-label">
            <label id="fileUpload.label">{{ uppercaseHeader ? (header | localize | uppercase) : (header | localize) }}</label>
            <span
                *ngIf="headerTooltip"
                role="img"
                class="agpr-infoIconStyle fa-regular fa-circle-info"
                [agprTooltip]="headerTooltip"
            ></span>
        </span>
        @if (showHeaderButton) {
            <div class="agpr-fileUpload-header--uploadButton">
                <agpr-button
                    id="fileUpload.uploadButton"
                    [disabled]="value?.length >= maxFiles || disabled"
                    [style]="!!uploadButtonLabel ? buttonTypes.tertiary : buttonTypes.icon"
                    [label]="uploadButtonLabel | localize | uppercase"
                    [icon]="uploadButtonIcon"
                    tooltip="Mention.editDialog.attachments.upload.tooltip"
                    tooltipPosition="left"
                    (click)="useContentLibraryUpload ? uploadButtonClick.emit() : fileUploadInput.click()"
                    [ariaDescribedBy]="'fileUpload.label'"
                ></agpr-button>
            </div>
        }
    </div>
    @if (showSubHeader) {
        <ng-container *ngTemplateOutlet="fileUploadSubHeader"></ng-container>
    }
    <ng-container *ngTemplateOutlet="inputContent"></ng-container>
</div>

<ng-template #fileUploadSubHeader>
        <div class="agpr-fileUpload-subHeader">
            <span class="agpr-fileUpload-subHeader--label">
                {{ 'Mention.workbench.subHeaderLabel' | localize : { maxFiles: this.maxFiles } }}
            </span>
            <div
                class="agpr-fileUpload-subHeader--uploadButton"
                [ngClass]="{'agpr-fileUpload-subHeader--addButton': uploadOptions}">
                @if (uploadOptions) {
                    <agpr-split-button
                        [id]="'fileUpload.uploadSplitButton'"
                        class="agpr-fileUpload-subHeader--splitButton"
                        icon="fa-regular fa-square-plus fa-duotone"
                        [style]="buttonTypes.icon"
                        [options]="uploadOptions"
                        tooltip="Mention.editDialog.attachments.uploadSplitButton.tooltip"
                        tooltipPosition="top"
                        [panelPositionY]="!value?.length ? 'top' : 'bottom'"
                        [panelPositionX]="'right'"
                        [disabled]="value?.length >= maxFiles || disabled"
                    ></agpr-split-button>
                }@else {
                    <agpr-button
                        id="fileUpload.uploadButton"
                        [disabled]="value?.length >= maxFiles || disabled"
                        [style]="!!uploadButtonLabel ? buttonTypes.tertiary : buttonTypes.icon"
                        [label]="uploadButtonLabel | localize | uppercase"
                        [icon]="uploadButtonIcon"
                        agprTooltip="Mention.editDialog.attachments.upload.tooltip"
                        tooltipPosition="left"
                        (click)="useContentLibraryUpload ? uploadButtonClick.emit() : fileUploadInput.click()"
                        [ariaDescribedBy]="'fileUpload.label'"
                    ></agpr-button>
                }
            </div>
        </div>
    </ng-template>

<ng-template #inputContent>
    <ng-container *ngFor="let file of value; let i = index">
        <div
        class="agpr-fileUpload-fileRow"
        [ngClass]="showThumbnail ? 'agpr-fileUpload-fileRow-thumbnail' : ''"
        >
            @if (showThumbnail) {
                <div class="agpr-fileUpload-fileRow-thumbnail-container">
                    @if ((file.url
                        && (file.mimeType === 'image/png' || file.mimeType === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpeg')
                        && !file.noThumbnail && !file.hasError)) {
                        <img
                            [src]="file.url + '?isThumbnail=true'"
                            [alt]="file.name"
                            class="agpr-fileUpload-fileRow-thumbnail-container--image"
                            (error)="file.noThumbnail = true"
                        >
                    } @else if (file.url && !file.hasError) {
                        <img
                            [src]="file.url"
                            [alt]="file.name"
                            class="agpr-fileUpload-fileRow-thumbnail-container--image"
                            (error)="file.hasError = true"
                        >
                    } @else {
                        <span [ngClass]="['thumbnail-container-default-icon', getFileIcon(file.mimeType)]"></span>
                    }
                </div>
            }
            <span
                [attr.role]="_allowFileDownload ? 'button' : ''"
                class="agpr-fileUpload-fileRow--file"
                [class.agpr-fileUpload-fileRow--fileLink]="_allowFileDownload"
                [attr.tabindex]="_allowFileDownload ? '0' : '-1'"
                (click)="_allowFileDownload ? downloadFile(file) : null"
            >
                <span [id]="id + '.fileName_' + i">{{ file.name }}</span>
                <span *ngIf="_allowFileDownload" class="hidden">{{ 'downloadLink' | localize }}</span>
            </span>
            <agpr-button
                [id]="id + '.deleteFileButton_' + i"
                [style]="buttonTypes.icon"
                [icon]="showThumbnail ? 'fa-regular fa-duotone fa-square-xmark' : 'fa-regular fa-duotone fa-trash-can'"
                (click)="removeFile(i)"
                class="agpr-fileUpload-fileRow--delete"
                tooltip="Discover.fileUpload.deleteFile"
                tooltipPosition="top"
                [ariaDescribedBy]="id + '.fileName_' + i"
            ></agpr-button>
        </div>
    </ng-container>

    @if(value?.length === 0 && shownoContentIcon){
        <agpr-message [severity]="messageSeverity.noContent" [useWhiteBg]="true">
            {{ placeholder | localize}}
        </agpr-message>
    }

    @if(value?.length === 0 && !shownoContentIcon){
        <div class="agpr-fileUpload-noIcon">
            {{ placeholder | localize}}
        </div>
    }

</ng-template>
<input
    #fileUploadInput
    style="display: none;"
    type="file"
    [multiple]="allowMultiple"
    [accept]="supportedFileTypes"
    (change)="addNewFile($event)"
    aria-hidden="true"
/>
